/* Holsper product page: loaded on any page whose product section uses Holsper blocks (see snippets/holsper-head.liquid).
   The theme re-renders parts of the buy box when the size changes, so everything here looks elements up fresh
   or uses event delegation. */
(function () {
  'use strict';

  var root = document.documentElement;
  var $ = function (s, r) { return (r || document).querySelector(s); };

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '£' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Current variant: the theme outputs it as JSON inside <variant-picker>; updated on "variant:change"
  var variant = null;
  function readVariant() {
    try {
      var vj = $('.product-info variant-picker script[data-variant]');
      if (vj) variant = JSON.parse(vj.textContent);
    } catch (e) { /* ignore */ }
  }

  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function tickedExtras() { return $$('.product-info [data-hx-addon]').filter(function (i) { return i.checked && !i.disabled; }); }

  // 1. Add to cart total. Only a CSS value changes, so the theme's "Add to cart" text never flickers.
  function updateAtcTotal() {
    var wantsTotal = $('.product-info [data-hx-price-in-button]');
    root.classList.toggle('hx-atc-total', !!wantsTotal);
    if (!wantsTotal || !variant) return;
    var total = variant.price;
    tickedExtras().forEach(function (i) { total += parseInt(i.dataset.hxAddonPrice, 10) || 0; });
    root.style.setProperty('--hx-atc-price', '"' + money(total) + '"');
  }

  // 1b. Extras start on the variant matching the set's options with the same name (e.g. Size). Every option has a
  //     picker; once the customer picks a value it is kept ("manual") even when the set's size changes.
  //     Sold-out values are struck through; a sold-out pick disables the tick box. Compare-at price shown when higher.
  function norm(x) { return String(x == null ? '' : x).toLowerCase().trim(); }
  function syncExtra(card) {
    var wrap = card.closest('[data-hx-main-options]');
    if (!variant || !wrap) return;
    try {
      if (!card._hxVariants) card._hxVariants = JSON.parse($('[data-hx-extra-variants]', card).textContent);
      if (!card._hxOptions) card._hxOptions = JSON.parse(card.dataset.hxExtraOptions || '[]');
      if (!wrap._hxMain) wrap._hxMain = JSON.parse(wrap.dataset.hxMainOptions || '[]');
    } catch (e) { return; }
    card._hxManual = card._hxManual || {};
    var fromSet = {};
    wrap._hxMain.forEach(function (name, i) { fromSet[norm(name)] = norm((variant.options || [])[i]); });
    var current = {};
    $$('[data-hx-extra-opt]:checked', card).forEach(function (r) { current[r.dataset.hxExtraOpt] = norm(r.value); });
    // What we want for each option: the customer's pick, else the set's value, else what is shown now
    var want = card._hxOptions.map(function (name, i) {
      if (card._hxManual[i] !== undefined) return card._hxManual[i];
      if (fromSet[norm(name)] !== undefined) return fromSet[norm(name)];
      return current[i];
    });
    var fits = function (v) { return want.every(function (w, i) { return w === undefined || norm(v.options[i]) === w; }); };
    var exact = card._hxVariants.filter(fits);
    var v = exact.filter(function (x) { return x.available; })[0] || exact[0] || card._hxVariants[0];
    if (!v) return;
    var sold = !v.available;
    var box = $('[data-hx-addon]', card);
    box.dataset.hxAddon = v.id;
    box.dataset.hxAddonPrice = v.price;
    box.disabled = sold;
    if (sold) box.checked = false;
    card.classList.toggle('is-soldout', sold);
    var price = $('[data-hx-extra-price]', card);
    if (price) price.textContent = '+ ' + money(v.price);
    var cmp = $('[data-hx-extra-compare]', card);
    if (cmp) { cmp.hidden = !(v.compare > v.price); cmp.textContent = money(v.compare || 0); }
    if (price && price.parentNode) price.parentNode.classList.toggle('is-sale', v.compare > v.price);
    var shared = parseInt(card.dataset.hxSharedIndex, 10);
    var size = $('[data-hx-extra-size]', card);
    if (size && shared >= 0) size.textContent = v.options[shared];
    card.classList.toggle('is-same', shared >= 0 && fromSet[norm(card._hxOptions[shared])] === norm(v.options[shared]));
    // Pickers: show the chosen variant, strike through values that are sold out with the other choices
    $$('[data-hx-extra-opt]', card).forEach(function (r) {
      var i = parseInt(r.dataset.hxExtraOpt, 10);
      r.checked = norm(r.value) === norm(v.options[i]);
      var ok = card._hxVariants.some(function (x) {
        return x.available && norm(x.options[i]) === norm(r.value) && x.options.every(function (o, j) { return j === i || norm(o) === norm(v.options[j]); });
      });
      r.closest('.hx-extra__opt').classList.toggle('is-out', !ok);
    });
  }
  function syncExtras() { $$('.product-info [data-hx-extra]').forEach(syncExtra); }

  // 2. Badges (Easy Change / New) on the main photo instead of above the title
  function moveBadges() {
    var list = $('.product-info [data-block-type="badges"] .product-info__badge-list');
    var gallery = $('product-gallery .product-gallery__media-list-wrapper') || $('product-gallery');
    if (!list || !gallery || $('.hx-photo-badges', gallery)) return;
    var clone = list.cloneNode(true);
    clone.className = 'hx-photo-badges';
    gallery.appendChild(clone);
    root.classList.add('hx-badges-moved');
  }

  // 3. Set includes: the sheet card follows the "Sheet" option
  function updateSheetCard() {
    var set = $('.product-info [data-hx-set]');
    if (!set || !variant || set.dataset.hxSheetIndex === undefined) return;
    var value = ((variant.options || [])[parseInt(set.dataset.hxSheetIndex, 10)] || '').toLowerCase();
    var card = $('[data-hx-sheet-card]', set);
    if (!card) return;
    card.hidden = value.indexOf((set.dataset.hxNo || 'no').toLowerCase()) === 0;
    var flat = value.indexOf('flat') !== -1;
    var label = $('[data-hx-sheet-label]', card);
    if (label) label.textContent = flat ? set.dataset.hxFlatLabel : set.dataset.hxFittedLabel;
    var img = $('img', card);
    if (img) img.src = flat ? set.dataset.hxFlatIcon : set.dataset.hxFittedIcon;
  }

  // 4. Extras: after the theme adds the set, add the ticked extras and refresh the cart drawer
  var addingAddon = false;
  document.addEventListener('variant:add', function (event) {
    var ticked = tickedExtras();
    if (!ticked.length || addingAddon) return;
    var ids = ticked.map(function (i) { return parseInt(i.dataset.hxAddon, 10); });
    var items = (event.detail && event.detail.items) || [];
    if (!items.some(function (i) { return ids.indexOf(i.variant_id) === -1; })) return;
    addingAddon = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    })
      .then(function (r) { return r.json(); })
      .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }) // the theme's documented full cart refresh
      .catch(function () { /* the set itself is already in the cart */ })
      .then(function () { addingAddon = false; });
  });

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t.matches) return;
    if (t.matches('[data-hx-extra-opt]')) {
      var card = t.closest('[data-hx-extra]');
      card._hxManual = card._hxManual || {};
      card._hxManual[t.dataset.hxExtraOpt] = norm(t.value); // keep the customer's own choice
      syncExtra(card);
      var box = $('[data-hx-addon]', card);
      if (box && !box.disabled) box.checked = true; // picking a size or style means they want it
    }
    if (t.matches('[data-hx-addon], [data-hx-extra-opt]')) updateAtcTotal();
  });

  // 5. Offer coupon: tap to copy the code
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-hx-code]');
    if (!btn) return;
    var code = btn.getAttribute('data-hx-code');
    var label = $('[data-hx-code-label]', btn) || btn;
    var done = function () { label.textContent = 'Copied'; setTimeout(function () { label.textContent = code; }, 1600); };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, done);
    else done();
  });

  // 6. Colour name preview while hovering a dot (desktop)
  document.addEventListener('mouseover', function (event) {
    var name = $('.product-info [data-hx-colour-name]');
    if (!name) return;
    if (!name.dataset.hxOriginal) name.dataset.hxOriginal = name.textContent;
    var dot = event.target.closest && event.target.closest('.hx-colours .hx-dot[title]');
    name.textContent = dot ? dot.getAttribute('title') : name.dataset.hxOriginal;
  });

  // Size / sheet changes
  document.addEventListener('variant:change', function (event) {
    if (event.detail && event.detail.variant) variant = event.detail.variant;
    syncExtras();
    updateAtcTotal();
    setTimeout(updateSheetCard, 0);
  });

  function init() {
    readVariant();
    moveBadges();
    updateSheetCard();
    syncExtras();
    updateAtcTotal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
